"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Food = function Food(_ref) {
  var viewBox = _ref.viewBox;
  return /*#__PURE__*/_react.default.createElement(_IconWrapper.default, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.187 6.89809C22.187 8.51466 21.5651 9.95161 20.5879 11.1191C22.8089 12.2866 23.3419 14.7115 22.8089 17.2262C22.0093 20.6389 19.5218 23.9619 16.8567 23.9619C16.1459 23.9619 15.4352 23.7822 14.9022 23.423C14.5468 23.6924 14.1026 23.872 13.6584 23.9619C10.7267 24.4109 7.9727 20.8185 7.17315 17.2262C6.01823 11.4784 10.9044 9.32294 14.0138 11.2089C13.8361 10.0414 13.3919 8.78409 12.3258 8.69428C11.7928 8.69428 11.4374 8.15542 11.5263 7.70638C11.6151 7.25733 12.0593 6.89809 12.5035 6.89809C14.1915 7.07771 15.1687 8.42485 15.5241 9.8618C16.5013 7.61657 18.7223 6 21.2986 6C21.8317 6 22.187 6.35924 22.187 6.89809Z",
    fill: "#DEE566"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.5879 11.1191C21.5651 9.95161 22.187 8.51466 22.187 6.89809C22.187 6.35924 21.8317 6 21.2986 6C18.7223 6 16.5013 7.61657 15.5241 9.8618C15.1687 8.42485 14.1915 7.07771 12.5035 6.89809C12.0593 6.89809 11.6151 7.25733 11.5263 7.70638C11.4374 8.15542 11.7928 8.69428 12.3258 8.69428C13.3919 8.78409 13.8361 10.0414 14.0138 11.2089C10.9044 9.32294 6.01823 11.4784 7.17315 17.2262C7.9727 20.8185 10.7267 24.4109 13.6584 23.9619C14.1026 23.872 14.5468 23.6924 14.9022 23.423C15.4352 23.7822 16.1459 23.9619 16.8567 23.9619C19.5218 23.9619 22.0093 20.6389 22.8089 17.2262C23.3419 14.7115 22.8089 12.2866 20.5879 11.1191ZM20.3214 7.9758C19.966 9.68218 18.6334 10.9395 17.0343 11.2987C17.3897 9.68218 18.6334 8.33504 20.3214 7.9758ZM21.0321 16.7771C20.4102 19.7408 18.1892 22.3453 16.5901 22.0759C16.3236 21.9861 16.0571 21.8962 15.7906 21.8064C15.2575 21.537 14.6357 21.4472 14.1026 21.8064C13.8361 21.9861 13.5696 22.0759 13.3031 22.0759C11.6151 22.3453 9.48297 19.7408 8.8611 16.7771C7.9727 12.4663 11.5263 11.2089 13.7473 13.2746C14.3691 13.9032 15.4352 13.9032 16.2348 13.1847C17.1232 13.1847 18.1004 12.9153 18.9888 12.3765C21.0321 12.9153 21.4763 14.7115 21.0321 16.7771Z",
    fill: "#9EBF43"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.1869 6.89809C22.1869 8.51466 21.565 9.95161 20.5877 11.1191C19.9998 11.7071 19.877 11.8376 18.9886 12.3765C18.1002 12.9153 17.123 13.1847 16.2346 13.1847C15.3462 13.1847 14.5467 12.107 15.5239 9.8618C16.5011 7.61657 18.7221 6 21.2985 6C21.8315 6 22.1869 6.35924 22.1869 6.89809Z",
    fill: "#2E7D32"
  }));
};

Food.propTypes = {
  viewBox: _propTypes.PropTypes.string
};
Food.defaultProps = {
  viewBox: '0 0 30 30'
};
var _default = Food;
exports.default = _default;